import _lib from '../_lib';
import active from './active/index';
import {CurrentProcNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'currentproc';
  let activations = [
    {
      name: 'currentproc',
      test: api.messageIs(CurrentProcNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};